// import { GenerateXMLButton } from "components/GenerateXMLButton";

import { Box, Toolbar } from "@mui/material";
import {
  DeleteButton,
  RHookFormTextField,
  SplitButton,
  SubmitButton,
} from "@websential/cosmic";

import { FC } from "react";
import { IAppState } from "../../../store/reducers";
import PlaylistAddCheckOutlinedIcon from "@mui/icons-material/PlaylistAddCheckOutlined";
import PrintIcon from "@mui/icons-material/Print";
import { useSelector } from "react-redux";

export interface IRL1SummaryToolbar {
  // onGenerateXMLClicked: () => void;
  onPrintClicked: (selectedItem: string, index: number) => void;
  onDeleteClicked: () => void;
  isSubmitting: boolean;
}

export const RL1SummaryToolbar: FC<IRL1SummaryToolbar> = ({
  // onGenerateXMLClicked,
  onPrintClicked,
  onDeleteClicked,
  isSubmitting = false,
}) => {
  const isAdminUser = useSelector((state: IAppState) => state.user.profile.isSuperStatus)
  return (
    <Toolbar>
      <>
        <div style={{ display: "flex", width: "50%" }}>
          <div
            style={{
              alignSelf: "center",
              paddingTop: "3px",
              paddingRight: "12px",
            }}
          >
            <SubmitButton
              label="Submit"
              testId="submit-button"
              loading={isSubmitting}
              icon={<PlaylistAddCheckOutlinedIcon />}
            />
          </div>
          <RHookFormTextField
            id="confirmationNumber"
            testId={"confirmation-number"}
            placeholder="Confirmation Number"
          />
          {isAdminUser === 1 ?
            <Box sx={{ display: "flex", alignItems: "center" }}>
              <DeleteButton
                onClickHandler={onDeleteClicked}
                testId="delete-button"
              />
            </Box>
            : <></>}
        </div>
        <div style={{ flexGrow: 1 }} />
        <div>
          <SplitButton
            options={["Print PDF (English)", "Print PDF (French)"]}
            onClickHandler={onPrintClicked}
            testId="t4-print-button"
            icon={<PrintIcon />}
            listItemsLabel={`Print Summary  `}
          />
        </div>
      </>
    </Toolbar>
  );
};
